import { fabric } from "fabric";
import { initControls, addObjectToCanvas } from "../utils/canvasUtils";
import { BASE_ORIGIN_OPTIONS } from "../constants/canvasConstants";
import { TextOptions } from "../types/textTypes";
import type { Canvas, Object } from "../types/canvasTypes";

const DEFAULT_TEXT = "Text sample";

export function createText(options: TextOptions) {
  const text = new fabric.Textbox(DEFAULT_TEXT, {
    ...BASE_ORIGIN_OPTIONS,
    ...options,
  });
  initTextOnCanvas(text);
  initControls(text);

  return text;
}

export function createAndAddTextToCanvas(canvas: Canvas, options: TextOptions) {
  const text = createText(options);
  addObjectToCanvas(canvas, text, { isCentered: true });
}

export function initTextOnCanvas(text: Object) {
  text.setControlsVisibility({
    mb: false,
  });
}

export function isText(obj: Object): obj is fabric.Textbox {
  return obj.type === "textbox";
}

export function isTextEditingState(obj: Object) {
  return isText(obj) && obj.isEditing;
}
